/* eslint-disable react/react-in-jsx-scope */
import './style.css'
import Course from '../../Helper/HomePageCourse/CourseBox'
import Form from '../../components/Form/Form'
import { useNavigate } from 'react-router-dom'
import CourseData from './../../courses'
import ScrollToForm from './../../Helper/scroll/scrollForm'
import Polygon from '../../img/Polygon 5.png'
import { useEffect } from 'react'


const Home = () => {

  const navigate = useNavigate()
  const scrollToFormFunc = ScrollToForm(navigate)

  useEffect(() => {
    const targetId = sessionStorage.getItem('scrollTargetId')
    if (targetId) {
      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth',
        })
        sessionStorage.removeItem('scrollTargetId')
      }
    }
  }, [])

  return (
    <>
      <section className="top center">
        <section className="top-content  ">
          <h1 className="top-content-title">
            <span className="yellow-span">FREE SUN</span> FILM SCHOOL
          </h1>
          <h2 className="top-content-slogan">
            —&nbsp;БУДЬ&nbsp;В&nbsp;ФОКУСЕ&nbsp;КИНО!
          </h2>
          <p className="top-content-text top-content-text-1">
            FREE SUN FILM SCHOOL предлагает{' '}
            <span className="yellow-span">уникальные</span> образовательные
            программы, закрывающие пробелы в&nbsp;кинообразовании.
            Киношкола&nbsp;сосредоточена на&nbsp;детальном изучении процессов
            кинопроизводства и&nbsp;практическом закреплении знаний.
          </p>
          <p className="top-content-text top-content-text-2">
            Студенты получают продуктивную обратную связь от кураторов и
            мастеров курсов на&nbsp;протяжении всего обучения.
            Лучшие&nbsp;выпускники гарантированно получают
            <span className="yellow-span">
              {' '}
              «Золотой&nbsp;бонус» — поддержку и&nbsp;продвижение
              в&nbsp;киноиндустрии
            </span>
            . Мы&nbsp;создаем&nbsp;прочную основу для&nbsp;успешной карьеры
            в&nbsp;мире кино.
          </p>

          <button className="top-content-btn" onClick={scrollToFormFunc}>
            ИДУ В КИНО
          </button>
        </section>
      </section>
      <img
        className=" polygon polygon-top center-footer"
        src={Polygon}
        alt=""
      />
      <Course courseData={CourseData} />
      <img className="polygon center-footer" src={Polygon} alt="" />
      <Form />
    </>
  )
}

export default Home
